<template>
  <!-- <div class="login">
    <input
      type="text"
      v-model="ruleForm.account"
    >
    <input
      type="text"
      v-model="ruleForm.password"
    >
    <button @click="handleLogin">登录</button>
  </div> -->
</template>

<script>
export default {
  name: "Login",
  data () {
    return {
      // ruleForm: {
      //   account: "",
      //   password: "",
      // },
    };
  },
  created () {
    var _this = this;
    var token = _this.$cookies.get("member_token");
    var tok = _this.$cookies.get("tok");
    if (token === null)
    {
      let url = "/ac1/conference/loginJump";
      _this.$get(url).then((res) => {
        var login_url = res.posts.login_url;
        var login_jump = res.posts.login_jump;
        var xianxiao_url = res.posts.xianxiao_url;
        var conference_url = res.posts.conference_url;
        _this.$cookies.set("login_jump", login_jump);
        _this.$cookies.set("xianxiao_url", xianxiao_url);
        _this.$cookies.set("conference_url", conference_url);
        _this.$cookies.set("login_url", login_url);
        window.location.href = login_url;
        return false;
      });
    } else
    {
      var tok = token;
      var url = "/ac1/conference/memberInfo";
      var params = {
        Authorization: tok
      };
      _this.$get(url, params).then(res => {
        if (res.code == 1)
        {
          localStorage.setItem("token",tok)
          localStorage.setItem("team", JSON.stringify(res.posts.team));
          localStorage.setItem("conferenceAUserinfo", JSON.stringify(res.posts));
          localStorage.setItem("name", res.posts.name);
          localStorage.setItem("dep_is_auth", res.posts.dep_is_auth)
          _this.$router.push({
            path: "/home",
          });
        } else if (
          res.code == 0 &&
          res.msg == "无权限，原因：会员不属于任何机构！"
        )
        {
          _this.$router.push("/nopeople");
        }
      });
    }
  },
  methods: {
    // handleLogin () {
    //   var _this = this;
    //   let url = this.APIurl.API.api.login;
    //   let params = this.ruleForm;
    //   _this
    //     .$post(url, params)
    //     .then((res) => {
    //       console.log(res);
    //       if (res.code == 1)
    //       {
    //         const { token } = res.posts;
    //         sessionStorage.setItem("name", res.posts.member_info.name);
    //         sessionStorage.setItem("token", token);
    //         _this.$cookies.set("xianxiao_url", "https://xxsy.ctft.net");
    //         _this.$cookies.set(
    //           "conference_url",
    //           "https://xxsy.ctft.net/index/conference/index.html"
    //         );
    //         var tok = sessionStorage.getItem("token");
    //         var url = "/ac1/conference/memberInfo";
    //         var params = {
    //           Authorization: tok,
    //         };
    //         _this.$get(url, params).then((res) => {
    //           console.log(res);
    //           if (res.code == 1)
    //           {
    //             localStorage.setItem("token", tok)
    //             localStorage.setItem("team", JSON.stringify(res.posts.team));
    //             localStorage.setItem("name", res.posts.name);
    //             localStorage.setItem("dep_is_auth", res.posts.dep_is_auth);
    //             localStorage.setItem("team_is_auth", res.posts.team_is_auth);
    //             _this.$router.push({
    //               path: "/home",
    //             });
    //           } else if (
    //             res.code == 0 &&
    //             res.msg == "无权限，原因：会员不属于任何机构！"
    //           )
    //           {
    //             _this.$router.push("/nopeople");
    //           }
    //         });
    //       } else
    //       {
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
  },
  mounted () {

  },
};
</script>
<style scoped>
</style>
